export default __webpack_public_path__ + "static/media/confirm-btn.57117718.png";